import api from 'service/api'

const dponetAPI = api.create('dponet')

const getAll = async (params) => {
  return await dponetAPI.get(`/tickets`, { params })
}

const get = async ({ ticketId = '', ...params }) => {
  return await dponetAPI.get(`/tickets/${ticketId}`, { params })
}

const update = async ({ ticketId, ...data }) => {
  return await dponetAPI.put(`/tickets/${ticketId}`, { ticket: data })
}

const createMessage = async ({ ticketId, ...data }) => {
  return await dponetAPI.postForm(`/tickets/${ticketId}/messages`, {
    ticketMessages: data,
  })
}

const showMessages = async ({ ticketId = '', ...params }) => {
  return await dponetAPI.get(`/tickets/${ticketId}/messages`, { params })
}

const createTicketFeedback = async ({ ticketId, ticketFeedback }) => {
  return await dponetAPI.post(`/tickets/${ticketId}/feedbacks`, {
    ticketFeedback,
  })
}

const tickets = {
  createMessage,
  createTicketFeedback,
  get,
  getAll,
  showMessages,
  update,
}

export default tickets
